import { render } from "./EditProfile.vue?vue&type=template&id=142b6880"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Vibration services Picture\\ProSchedule\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__